(() => {
  const enhanceArticles = (scope) => {
    scope.querySelectorAll('.ak-article-body').forEach((body) => {
      const firstHeading = body.querySelector('h1,h2,h3,h4,h5,h6');
      const intro = Array.from(body.querySelectorAll('p')).find((paragraph) => {
        if (!paragraph.textContent.trim() || paragraph.closest('table,figure,figcaption,blockquote,li,script,style,template,noscript,.gn-faq,.ak-faq')) return false;
        return !firstHeading || Boolean(paragraph.compareDocumentPosition(firstHeading) & Node.DOCUMENT_POSITION_FOLLOWING);
      });
      if (intro) intro.classList.add('ak-article-intro');
      body.querySelectorAll('table').forEach((table) => {
        if (table.closest('.ak-table-scroll')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'ak-table-scroll';
        table.before(wrapper);
        wrapper.append(table);
        if (wrapper.scrollWidth > wrapper.clientWidth) {
          wrapper.tabIndex = 0;
        }
      });
      body.querySelectorAll('h2').forEach((heading) => {
        if (!/\bfaqs?\b|\bfrequently\s+asked\s+questions\b/i.test(heading.textContent)) return;
        heading.classList.add('ak-faq-title');
        let sibling = heading.nextElementSibling;
        while (sibling && sibling.tagName !== 'H2') {
          if (sibling.tagName === 'H3' && sibling.nextElementSibling?.tagName === 'P') {
            sibling.classList.add('ak-faq-question');
            sibling.nextElementSibling.classList.add('ak-faq-answer');
          }
          sibling = sibling.nextElementSibling;
        }
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceArticles(document), {once: true});
  } else {
    enhanceArticles(document);
  }
  document.addEventListener('shopify:section:load', (event) => enhanceArticles(event.target));
})();
